/**
 * 备注模块
 */
import React from 'react';

import ContentBlock from '@/components/Reservation/ContentBlock';
import TextArea from '@/components/Reservation/TextArea';
import styles from './index.module.scss';

interface IProps {
  value: string;
  title: string;
  placeholder: string;
  disabled?: boolean;
  onChange: (value: string) => void;
}

const Index: React.FC<IProps> = (props) => {
  const { value, title, placeholder, onChange, disabled = false } = props;

  // 备注信息修改
  const handleRemarkChange = (val) => {
    if (disabled) return;
    onChange(val);
  };

  return (
    <ContentBlock title={title} className={styles.remarkInfo}>
      <TextArea
        className={styles.remarkTextarea}
        placeholder={placeholder}
        maxLength={10000}
        rows={3}
        autoSize
        value={value}
        disabled={disabled}
        onChange={handleRemarkChange}
      />
    </ContentBlock>
  );
};

export default Index;
